let FontService
if (window.FontFace) {
  FontService = require('./src/FontServiceFontFace').default
} else {
  FontService = require('./src/FontServiceObserver').default
}

export default FontService
